import React, { Fragment, useEffect, useState } from 'react'
import "./OrderDetails.css";
import moment from "moment-timezone";


import Input from '../UI/Input';
import { useAuth0 } from '@auth0/auth0-react';

const ImagingOrderDetails = ({ workFlowIdentifier, orderObj, comradErrorList, inputChangedHandler, show_pediatrician, patient_age }) => {
  const { user } = useAuth0();
  if (orderObj?.DOB && orderObj?.DOB?.length == 10) {
    let age = Math.floor(moment(new Date()).diff(moment(orderObj?.DOB, "DD/MM/YYYY"), 'years', true))

    if (age < 12 && age > 0) {
      show_pediatrician = true
      patient_age = age;

    }
  }
  else {
    show_pediatrician = false
  }

console.log("orderObj",orderObj)

  return (
    <Fragment>
      <div
        className={
          workFlowIdentifier === "GP_WORKFLOW"
            ? "section__separation1"
            : "section__separation"
        }
      // style={{
      //   borderTop:
      //     workFlowIdentifier != "GP_WORKFLOW" && "1px solid lightgrey",
      // }}
      >
        <table>
          <tr>
            <td style={{ width: "5%", fontSize: "14" }} title={"First name"}>
              FN:{" "}
            </td>
            <td>
              <Input
                id="firstname"
                label="Given name"
                elementType="input"
                key="givenname"
                name="first_name"
                width="90%"
                textTransform="capitalize"
                placeholder="Ex. Clinton"
                Value={orderObj.first_name}
                onChange={(event) => {
                  inputChangedHandler(event, "first_name");
                }}
                disabled={user?.oi_profile && user?.oi_profile?.toLowerCase() == "customer" && orderObj?.Operator_Feedback?.operator_feedback=="1001"}
                customStyle={{
                  borderColor:
                    Array.isArray(comradErrorList) &&
                    comradErrorList.length > 0 &&
                    comradErrorList[0] &&
                    comradErrorList[0].patient_firstname &&
                    comradErrorList[0].patient_firstname?.toLowerCase() !==
                    orderObj.first_name.toLowerCase() &&
                    "red",
                }}
                error_text={
                  Array.isArray(comradErrorList) &&
                  comradErrorList.length > 0 &&
                  comradErrorList[0] &&
                  comradErrorList[0].patient_firstname &&
                  comradErrorList[0].patient_firstname?.toLowerCase() !==
                  orderObj.first_name.toLowerCase() &&
                  `First name in comrad is ${comradErrorList[0].patient_firstname}`
                }
                
              />
            </td>
            <td style={{ width: "5%", fontSize: "14" }} title={"Last name"}>
              LN:{" "}
            </td>
            <td>
              <Input
                id="lastname"
                key="surname"
                label="Surname"
                elementType="input"
                name="last_name"
                width="100%"
                textTransform="capitalize"
                placeholder="Ex. Marx"
                Value={orderObj.last_name}
                onChange={(event) => {
                  inputChangedHandler(event, "last_name");
                }}
                disabled={user?.oi_profile && user?.oi_profile?.toLowerCase() == "customer" && orderObj?.Operator_Feedback?.operator_feedback=="1001"}
                customStyle={{
                  borderColor:
                    Array.isArray(comradErrorList) &&
                    comradErrorList.length > 0 &&
                    comradErrorList[0] &&
                    comradErrorList[0].patient_lastname &&
                    comradErrorList[0].patient_lastname?.toLowerCase() !==
                    orderObj.last_name.toLowerCase() &&
                    "red",
                }}
                error_text={
                  Array.isArray(comradErrorList) &&
                  comradErrorList.length > 0 &&
                  comradErrorList[0] &&
                  comradErrorList[0].patient_lastname &&
                  comradErrorList[0].patient_lastname?.toLowerCase() !==
                  orderObj.last_name.toLowerCase() &&
                  `Last name in comrad is ${comradErrorList[0].patient_lastname}`
                }
              />
            </td>

          </tr>

          <tr>
            <td
              style={{ width: "5%", fontSize: "14" }}
              title={"Date of birth"}
            >
              DOB:
            </td>
            <td>
              <Input
                id="DOB"
                key="dob"
                label="DOB"
                elementType="input"
                name="DOB"
                width="90%"
                textTransform="none"
                placeholder="dd/mm/yyyy"
                Value={orderObj.DOB}
                disabled={user?.oi_profile && user?.oi_profile?.toLowerCase() == "customer" && orderObj?.Operator_Feedback?.operator_feedback=="1001"}
                onChange={(event) => {
                  inputChangedHandler(event, "DOB");
                }}
                customStyle={{
                  borderColor:
                    Array.isArray(comradErrorList) &&
                    comradErrorList.length > 0 &&
                    comradErrorList[0].patient_dob &&
                    orderObj.DOB !==
                    moment(comradErrorList[0].patient_dob).format(
                      "DD/MM/YYYY"
                    ) &&
                    "red",
                }}
                error_text={
                  Array.isArray(comradErrorList) &&
                  comradErrorList.length > 0 &&
                  comradErrorList[0].patient_dob &&
                  orderObj.DOB !==
                  moment(comradErrorList[0].patient_dob).format(
                    "DD/MM/YYYY"
                  ) &&
                  `DOB in comrad is ${moment(
                    comradErrorList[0].patient_dob
                  ).format("DD/MM/YYYY")}`
                }
              />
            </td>

            <td style={{ width: "5%", fontSize: "14" }} title={"Contact"}>
              CT:
            </td>
            <td>
              <div style={{ display: 'flex' }}>
                <Input
                  id="contact"
                  key="contact_details"
                  label="Contact"
                  elementType="input"
                  name="contact"
                  width="100%"
                  textTransform="none"
                  placeholder="Contact"
                  disabled={user?.oi_profile && user?.oi_profile?.toLowerCase() == "customer" && orderObj?.Operator_Feedback?.operator_feedback=="1001"}
                  Value={!orderObj.contact ? "" : orderObj.contact}
                  onChange={(event) => {
                    inputChangedHandler(event, "contact");
                  }}
                />
                <div style={{ height: '30px', width: '30px', background: '#fff', border: '1px solid #fefefe', fontSize: '15px', marginLeft: '3px', borderRadius: '5px', textAlign: 'center' }}><div style={{ padding: '5px' }}>{orderObj?.contact?.includes("+61") ? orderObj?.contact?.length - 3 : (orderObj?.contact === null ? 0 : orderObj?.contact?.length)}</div></div>
              </div>

            </td>

          </tr>
          {orderObj.send_instructions_over_email==true && 
          <tr>
            <td
              style={{ width: "5%", fontSize: "14" }}
              title={"Email"}
            >
              Email:
            </td>
            <td>
              <Input
                id="Email"
                key="email_id"
                label="Email"
                elementType="input"
                name="Email"
                width="215%"
                textTransform="none"
                placeholder="john.doe@testmail.com"
                Value={orderObj.email_id}
                onChange={(event) => {
                  inputChangedHandler(event, "email_id");
                }}
              />
            </td>
          </tr>}
        </table>
        {show_pediatrician == true && <><div style={{ marginLeft: '32px', marginTop: '5px', background: 'rgba(255, 127, 80, 0.5)', padding: '8px', borderRadius: '5px', width: '195px', color: '#000' }}>Pediatric case (Age - {patient_age})</div></>}

      </div>

    </Fragment>
  )
}

export default ImagingOrderDetails